import { curry } from "ramda";

export const fold = curry((left, right, foldable) =>
  foldable.fold(left, right)
);
